"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Col = _interopRequireDefault(require("./Col"));

var _default = _Col["default"];
exports["default"] = _default;